function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.46,0A12.46,12.46,0,1,0,24.91,12.46,12.46,12.46,0,0,0,12.46,0Zm0,24.16a11.71,11.71,0,1,1,11.7-11.7A11.72,11.72,0,0,1,12.46,24.16Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.87,8H15L13.15,4.72a.79.79,0,0,0-.69-.41.81.81,0,0,0-.7.41L9.88,8H6a.81.81,0,0,0-.69,1.21L7.27,12.5,5.35,15.82A.8.8,0,0,0,6,17H9.88l1.88,3.26a.8.8,0,0,0,.7.4.78.78,0,0,0,.69-.4L15,17h3.84a.8.8,0,0,0,.69-1.2L17.64,12.5l1.92-3.32A.8.8,0,0,0,18.87,8ZM12.41,5.09s0,0,.05,0,0,0,0,0L14.17,8H10.74ZM14.6,8.72l1.11,1.92,1.07,1.86-1.07,1.85L14.6,16.28H10.31L9.2,14.35,8.13,12.5,9.2,10.64l1.11-1.92H14.6ZM6,8.8a0,0,0,0,1,0-.05,0,0,0,0,1,0,0H9.45l-.89,1.55L7.7,11.75Zm0,7.48a0,0,0,0,1,0,0,0,0,0,0,1,0-.06l1.7-2.94.86,1.48.89,1.55Zm6.46,3.63s0,0,0,0-.05,0-.05,0L10.74,17h3.43Zm6.42-3.72a.11.11,0,0,1,0,.06.05.05,0,0,1-.05,0H15.46l.9-1.55.85-1.48Zm0-7.39-1.71,2.95-.85-1.48-.9-1.55h3.41a.05.05,0,0,1,.05,0S18.92,8.79,18.92,8.8Z"
});

function SvgKosher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    fill: "currentColor",
    stroke: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.91 24.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKosher);
export default __webpack_public_path__ + "static/media/Kosher.a34edf1b.svg";
export { ForwardRef as ReactComponent };